import Container from '@mui/material/Container';

import InventoryHistory from '@/assets/sidebar/inventoryHistory';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import InventoryHistoryTable from '@/sections/Fulfill/InventoryHistory/Table/InventoryHistoryTable';

const InventoryHistoryPage = () => {
  usePageTitle('Fulfill99 - Órdenes de arribo');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Órdenes de arribo" mt={5}>
        <InventoryHistory fontSize="large" />
      </SectionTitle>
      <InventoryHistoryTable />
    </Container>
  );
};

export default InventoryHistoryPage;
